import { GetApiAnnouncementsResponse } from '@iwoca/lapi-client/announcements';
import { AlertBox } from '@iwoca/orion';

import styles from './AnnouncementsBanner.module.css';
import { useAnnouncementsQuery } from './useAnnouncementsQuery';

type TAnnouncement = GetApiAnnouncementsResponse['announcements'][number];

const SEVERITY_VARIANT: Record<
  TAnnouncement['severity'],
  'failure' | 'cancel'
> = {
  outage: 'failure',
  degraded: 'cancel',
};

export function AnnouncementsBanner() {
  const { data } = useAnnouncementsQuery();
  const announcements = data?.announcements;

  if (!announcements?.length) return null;

  return (
    <div className={styles.container}>
      {announcements.map((announcement, index) => (
        <AlertBox key={index} variant={SEVERITY_VARIANT[announcement.severity]}>
          <div className={styles.content}>
            <span className={styles.title}>{announcement.title}</span>
            <span className={styles.description}>
              {announcement.description}
            </span>
          </div>
        </AlertBox>
      ))}
    </div>
  );
}
